import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _DEPLOY_ACTIONS, _reducerStateMap;
export var DEPLOY_MODE = {
  STATIC_SITE: 'STATIC_SITE',
  ISR_SITE: 'ISR_SITE'
};
export var DEPLOY_ACTIONS = (_DEPLOY_ACTIONS = {
  REVALIDATE_PATH: 'REVALIDATE_PATH',
  SYNC_APP: 'SYNC_APP',
  PUBLISHING: 'PUBLISHING',
  //orchestratorV2
  STAGING: 'STAGING'
}, _defineProperty(_DEPLOY_ACTIONS, "PUBLISHING", 'PUBLISHING'), _defineProperty(_DEPLOY_ACTIONS, "PUBLISHING_SCHEDULED", 'PUBLISHING_SCHEDULED'), _DEPLOY_ACTIONS);
export var reducerStateMap = (_reducerStateMap = {}, _defineProperty(_reducerStateMap, DEPLOY_ACTIONS.REVALIDATE_PATH, 'revalidate'), _defineProperty(_reducerStateMap, DEPLOY_ACTIONS.SYNC_APP, 'sync'), _defineProperty(_reducerStateMap, DEPLOY_ACTIONS.PUBLISHING, 'publishing'), _defineProperty(_reducerStateMap, DEPLOY_ACTIONS.STAGING, 'staging'), _reducerStateMap);
export var initialState = {
  revalidate: '',
  sync: '',
  publishing: '',
  //orchestratorV2
  staging: '' //orchestratorV2
  // stage: '',
  // publish: '',
  // stagePublish: '',
};

export var STATE_CLASSES = {
  DONE: '',
  LOADING: 'is-loading',
  ERROR: 'has-error'
};
export var INSTANT_PREVIEW_VERSION = {
  STAGE: 'STAGE',
  WIP: 'WIP'
};
export var INSTANT_PREVIEW_ENV = {
  PRODUCTION: 'PRODUCTION',
  UAT: 'UAT',
  DEV: 'DEV'
};
export var LOCK_STATUS = {
  LOCKED: 'LOCKED',
  UNLOCKED: 'UNLOCKED'
};